var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreFumigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7673 3.20573C12.7673 2.98383 12.5776 2.80396 12.3436 2.80396C12.1096 2.80396 11.9199 2.98383 11.9199 3.20573V17C11.9199 17.2219 12.1096 17.4018 12.3436 17.4018C12.5776 17.4018 12.7673 17.2219 12.7673 17V3.20573ZM7.23254 16.7638C7.23254 16.9857 7.42223 17.1656 7.65622 17.1656C7.89021 17.1656 8.07989 16.9857 8.07989 16.7638V3.20573C8.07989 2.98383 7.89021 2.80396 7.65622 2.80396C7.42223 2.80396 7.23254 2.98383 7.23254 3.20573L7.23254 16.7638Z",
    fill: "#1E3A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2318 1H6.76769C6.45501 1 6.20154 1.24038 6.20154 1.53689V2.66882C6.20154 2.96533 6.45501 3.20571 6.76769 3.20571H13.2318C13.5445 3.20571 13.798 2.96533 13.798 2.66882V1.53689C13.798 1.24038 13.5445 1 13.2318 1Z",
    fill: "#1E3A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 7.65186H10.8253V8.04316H7.52429V7.65186Z",
    fill: "#1E3A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1738H11.301V10.5651H8V10.1738Z",
    fill: "#1E3A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 6.47803H9.58744V6.86933H7.52429V6.47803Z",
    fill: "#1E3A8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H10.0631V9.3913H8V9Z",
    fill: "#1E3A8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 5.30444H10.8253V5.69575H7.52429V5.30444Z",
    fill: "#1E3A8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 14.3474H10.8253V14.7387H7.52429V14.3474Z",
    fill: "#1E3A8A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.8694H11.301V17.2607H8V16.8694Z",
    fill: "#1E3A8A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 13.1736H9.58744V13.5649H7.52429V13.1736Z",
    fill: "#1E3A8A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 11H9.58744V11.3913H7.52429V11Z",
    fill: "#1E3A8A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.6956H10.0631V16.0869H8V15.6956Z",
    fill: "#1E3A8A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 12H10.8253V12.3913H7.52429V12Z",
    fill: "#1E3A8A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87366 5.30427L4.21412 2.97866C2.52161 0.559565 0.0451139 2.90807 2.59601 4.51311L5.0484 6.08687L5.87366 5.30427Z",
    fill: "#1E3A8A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9514 13.9131L17.4038 15.4868C19.9547 17.0919 17.4782 19.4404 15.7857 17.0213L14.1262 14.6957L14.9514 13.9131Z",
    fill: "#1E3A8A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2014 14.7566L13.1063 13.7182V12.1731L15.016 13.9841L14.2014 14.7566Z",
    fill: "#1E3A8A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8938 7.82649L4.98411 6.01546L5.79875 5.24292L6.8938 6.28137V7.82649Z",
    fill: "#1E3A8A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7688 16.76C11.2852 16.76 12 18.5 10 18.5C12 18.5 8 18.5 10 18.5C8 18.5 8.5 16.5 7.23401 16.4999V13.7812V16.76C7.23401 18.2039 8.47933 19.3845 10.0014 19.3845C11.5234 19.3845 12.7688 18.2039 12.7688 16.76Z",
    fill: "#1E3A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreFumigation);
export default __webpack_public_path__ + "static/media/preFumigation.76f66a76609bcfa34d9318d82de9e405.svg";
export { ForwardRef as ReactComponent };